import Flow from '../flow.js';
import config from './mobile-config.js';
import validation from '../register/signup-validation.js';

let instance;

function MobileVerify() {
	const view = document.querySelector('.js-verify_phone-number');

	Flow.call(this, view, config, {
		stepSelector: '.js-verify-phone--step',
		openClass: 'menu--is-open'
	});

	validation.setupMobileValidation();
}

MobileVerify.prototype = Object.create(Flow.prototype);
MobileVerify.prototype.constructor = MobileVerify;

function get() {
	if (!(instance instanceof MobileVerify)) {
		instance = new MobileVerify();
	}
	return instance;
}

export default get;



// WEBPACK FOOTER //
// ./mobile-core/src/verification/mobile-verify.js